import { Injectable } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';

import {
  Plugins,
  PushNotification,
  PushNotificationToken,
  PushNotificationActionPerformed,
  LocalNotificationActionPerformed
} from '@capacitor/core';
import { AuthService } from './auth.service';
import { FirebaseService } from './firebase.service';

const { PushNotifications } = Plugins;
const { LocalNotifications } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class NotificacionesService {

  constructor(
    public platform: Platform,
    private auth: AuthService,
    private firebase: FirebaseService,
    public navCtrl: NavController
  ) {
    this.stateUser();
  }

  stateUser() {
    this.auth.getUidState().subscribe( res => {
      console.log(res);
      if (res !== null) {
        this.inicializar();
      }
    });
  }

  inicializar() {
    if (this.platform.is('capacitor')) {
      PushNotifications.requestPermission().then(result => {
        console.log('PushNotificacionts.requestPermission()');
        if (result.granted) {
          console.log('Permisos concedidos.');
          PushNotifications.register();
          this.addListeners();
        } else {
          console.log('No tiene Permisos concedidos.');
        }
      });
    } else {
      console.log('PushNotificacionts.requestPermission() -> no es movil');
    }
  }

  addListeners() {
    PushNotifications.addListener('registration',
      (token: PushNotificationToken) => {
        this.guardarToken(token.value);
        console.log('The token is:', token);
      }
    );

    PushNotifications.addListener('registrationError',
      (error: any) => {
        console.log('Error on registration', error);
      }
    );

    PushNotifications.addListener('pushNotificationReceived', // 1 Plano
      (notification: PushNotification) => {
        console.log('Push received:', notification);
        LocalNotifications.schedule({
          notifications: [
            {
              title: notification.title,
              body: notification.body,
              id: 1,
              extra: {
                data: notification.data
              }
            }
          ]
        });
      }
    );

    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: PushNotificationActionPerformed) => {
        console.log('Push action performed en segundo plano', notification);
        // Accion
        this.navCtrl?.navigateRoot(notification.notification.data.enlace);
       
      }
    );

    LocalNotifications.addListener('localNotificationActionPerformed',
      (notification: LocalNotificationActionPerformed) => {
        console.log('Push action performed en primer plano', notification);
        // Accion
        this.navCtrl?.navigateRoot(notification.notification.extra.data.enlace);
      }
    );

  }

  async guardarToken(token: any) {
    const Uid = await this.auth.getUid();
    if (Uid) {
      console.log('Guardar token firebase -> ', Uid);
      const path = '/usuarios/' + Uid;
      const userUpdate = {
        token: token,
      };
      this.firebase.updateDoc(path, userUpdate);
      console.log('Guardar Token ->', path, Uid);
    }
  }

  newNotification() {
    
  }

}
